module.exports = __webpack_public_path__ + "media/Components/fonts/Michroma-c12a12d1198168c8509709ee419ac6c0.ttf";